import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';
import ToggleDataPod from '../../../components/ToggleDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.profiles.annual-tuition.title',
    defaultMessage: 'Annual Tuition',
  },
  inState: {
    id: 'hubs.profiles.annual-tuition.in-state',
    defaultMessage: 'In-State',
  },
  outOfState: {
    id: 'hubs.profiles.annual-tuition.out-of-state',
    defaultMessage: 'Out-of-State',
  },
});

function AnnualTuition({ tuition, intl, lastUpdated }) {
  const values = [
    get(tuition, 'inState.value')
      ? {
          label: intl.formatMessage(messages.inState),
          value: get(tuition, 'inState.value'),
        }
      : false,
    get(tuition, 'outOfState.value')
      ? {
          label: intl.formatMessage(messages.outOfState),
          value: get(tuition, 'outOfState.value'),
        }
      : false,
  ].filter(i => i);
  const parser = value =>
    Number(value).toLocaleString('en-US', {
      minimumFractionDigits: 0,
    });

  return values.length ? (
    <ToggleDataPod
      header={intl.formatMessage(messages.title)}
      isToggle
      footer={lastUpdated}
      valueParser={parser}
      type="currency"
      content={{
        values,
      }}
    />
  ) : null;
}

export default injectIntl(AnnualTuition);

AnnualTuition.propTypes = {
  tuition: PropTypes.object,
  lastUpdated: PropTypes.string,
  intl: PropTypes.object,
};
